import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

interface KycRequiredModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companyId: string;
}

const KycRequiredModal: React.FC<KycRequiredModalProps> = ({
  open,
  onOpenChange,
  companyId
}) => {
  const navigate = useNavigate();
  const t = useTranslations('consultantBank.kycRequired');

  const handleCompleteKyc = () => {
    onOpenChange(false);
    navigate('/onboarding-steps');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center space-x-2">
            <AlertCircle className="h-5 w-5 text-orange-500" />
            <span>{t('title')}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="text-sm text-muted-foreground">
            <p className="mb-3">
              {t('body')}
            </p>
            <p>
              {t('reason')}
            </p>
          </div>

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              {t('cancel')}
            </Button>
            <Button onClick={handleCompleteKyc}>
              {t('complete')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default KycRequiredModal;
